import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "dropzone", "placeholder", "preview", "filename", "filesize", "fileicon"]

  connect() {
    this.setupDragAndDrop()
  }

  setupDragAndDrop() {
    if (!this.hasDropzoneTarget) return

    this.dropzoneTarget.addEventListener("dragover", (e) => {
      e.preventDefault()
      this.dropzoneTarget.classList.add("border-primary", "bg-primary/5")
    })

    this.dropzoneTarget.addEventListener("dragleave", (e) => {
      e.preventDefault()
      this.dropzoneTarget.classList.remove("border-primary", "bg-primary/5")
    })

    this.dropzoneTarget.addEventListener("drop", (e) => {
      e.preventDefault()
      this.dropzoneTarget.classList.remove("border-primary", "bg-primary/5")

      const files = e.dataTransfer.files
      if (files.length > 0) {
        this.inputTarget.files = files
        this.showPreview()
      }
    })
  }

  selectFile() {
    this.inputTarget.click()
  }

  showPreview() {
    const file = this.inputTarget.files[0]
    if (!file) return

    // Update filename (every name, when several are chosen)
    if (this.hasFilenameTarget) {
      this.filenameTarget.textContent = Array.from(this.inputTarget.files).map((f) => f.name).join(", ")
    }

    // Update filesize
    if (this.hasFilesizeTarget) {
      this.filesizeTarget.textContent = this.formatFileSize(file.size)
    }

    // Update icon based on file type
    if (this.hasFileiconTarget) {
      const isPDF = file.type === "application/pdf"
      this.fileiconTarget.className = isPDF
        ? "fa-solid fa-file-pdf text-red-500 text-2xl"
        : "fa-solid fa-file-image text-blue-500 text-2xl"
    }

    // Toggle visibility
    if (this.hasPlaceholderTarget) {
      this.placeholderTarget.classList.add("hidden")
    }
    if (this.hasPreviewTarget) {
      this.previewTarget.classList.remove("hidden")
    }
  }

  clear(e) {
    e.preventDefault()
    e.stopPropagation()

    this.inputTarget.value = ""

    if (this.hasPlaceholderTarget) {
      this.placeholderTarget.classList.remove("hidden")
    }
    if (this.hasPreviewTarget) {
      this.previewTarget.classList.add("hidden")
    }
  }

  formatFileSize(bytes) {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const sizes = ["Bytes", "KB", "MB", "GB"]
    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + " " + sizes[i]
  }
}
